import React, { Component, useState, Fragment } from 'react';
import moment from 'moment';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Format_Number, Loading } from '../index';
import Status from '../Status';

import { getPriceWithoutTax, provinceTaxes, roundToTwo } from '../../constants/taxes';

import { NavLink, withRouter } from 'react-router-dom';
import { convertUberUndeliverableReasonMessage } from '../../util/functions';
import { Format_Total_Number } from '../../actions/helper';

class DataTable extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <Table>{this.props.children}</Table>;
  }
}

const DataTableHead = (props) => {
  const { columns, sort, orderBy, style,
    onSelectAllClick,
    numSelected,
    rowCount,
    enableSelectionMode = false,
  } = props;
  const updateProps = (data) => {
    if (props.sort) props.sort(data);
  };
  let rightColums = ['action'];
  return (
    <TableHead>
      <TableRow>
        {enableSelectionMode && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all pharmacies' }}
            />
          </TableCell>
        )}
        {columns.length > 0 &&
          columns.map((column) => {
            return (
              <TableCell
                key={column.id}
                style={style}
                align={!rightColums.includes(column.id) ? 'left' : 'right'}
                padding={column.disablePadding ? 'none' : 'default'}
                onClick={() =>
                  updateProps({
                    key: column.id,
                    order: parseInt(column.order) === 1 ? -1 : 1,
                  })
                }
              >
                {column.label}
                {orderBy === column.id && orderBy.toLowerCase() !== 'action' && (
                  <TableSortLabel active={true} direction={column.order == 1 ? 'asc' : 'desc'} />
                )}
              </TableCell>
            );
          })}
      </TableRow>
    </TableHead>
  );
};
DataTableHead.defaultProps = {
  style: {},
};

const TableCellPrint = (Dkey, key, index) => {
  let notDisplay = ['_id', 'action'];
  let noImage = ['', null, undefined, 'none'];
  switch (key.type) {
    case 'tag': {
      return (
        <TableCell padding="none" align="center" style={key.style ? key.style : {}}>
          <span className={`label ${Dkey[key.id]}`}>
            {Status[Dkey[key.id]] ? Status[Dkey[key.id]] : Dkey[key.id] && Dkey[key.id].charAt(0).toUpperCase() + Dkey[key.id].slice(1)}
          </span>
          <span>
            {key.id === 'orderStatus' && (Dkey.orderStatus === 'cancelled' || Dkey.orderStatus === 'returned') && Dkey.undeliverableReason !== undefined && (
              <p style={{ backgroundColor: 'blue', color: '#fff', fontSize: '8px' }} className='my-2 p-1 rounded text-center'>
                {Dkey.undeliverableReason === undefined ? '' : convertUberUndeliverableReasonMessage(Dkey.undeliverableReason)}
              </p>
            )}
          </span>

        </TableCell>
      );
      break;
    }
    case "isDeliverToPharmacy": {
      return (
        <TableCell padding="none" align="left" style={key.style ? key.style : {}}>
          <span className={`label`}>
            {Dkey[key.id] ? 'Pickup' : 'Delivery'}
          </span>
        </TableCell>
      );
    }
    case "customerName": {
      return (
        <TableCell
          padding="none"
          align="center"
          key={index}
          style={{ whiteSpace: "pre-wrap", textAlign: "center" }}         >
          {Dkey[key.id] && Array.isArray(Dkey[key.id]) ? (
            Dkey[key.id].map((name, idx) => (
              <div key={idx} style={{ display: "block" }}>
                {name}
              </div>
            ))
          ) : (
            "--"
          )}
        </TableCell>
      );
    }

    case "shipmentaddress": {
      return (
        <TableCell
          padding="none"
          align="center"
          key={index}
          style={{ ...key.style }}
        >
          {Dkey[key.id] && Array.isArray(Dkey[key.id]) ? (
            Dkey[key.id].map((name, idx) => (
              <div key={idx} style={{ display: "block" }}>
                {name}
              </div>
            ))
          ) : (
            "--"
          )}
        </TableCell>
      );
    }
    case 'customerProfileId': {
      return (
        <TableCell padding="none" align="center" style={key.style ? key.style : {}}>
          {Dkey[key.id] ? Dkey[key.id] : '--'}
        </TableCell>
      );
      break;
    }

    case 'action': {
      return (
        <TableCell padding="none" align="left" style={key.style ? key.style : {}}>
          {key.action(Dkey)}
        </TableCell>
      );
      break;
    }
    case 'image': {
      return (
        <TableCell padding="none" key={index} align="left" style={key.style ? key.style : {}}>
          <div className="user-profile d-flex flex-row">
            <Avatar
              alt={Dkey['name']}
              src={!noImage.includes(Dkey[key.image]) ? Dkey[key.image] : require('assets/images/placeholder.jpg')}
              className="ml-3 user-avatar"
            />
            <div className="user-detail">
              <h5 className="user-name">{Dkey[key.id]} </h5>
            </div>
          </div>
        </TableCell>
      );
      break;
    }

    case 'date': {
      let format = key.date ? key.date : 'YYYY-MM-DD';

      const date = Dkey[key.id] ? moment(Dkey[key.id]).utc().format(format) : '--';

      const isFirstDateColumn = key.id === 'orderCreatedAt';

      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {date}
          <div>
            {Dkey.recurringOrder && isFirstDateColumn && (
              <>
                <div style={{ marginBottom: '5px' }}>
                  <span style={{ marginRight: '5px' }} className={`label `}>
                    {Dkey.recurrence}
                  </span>

                  <span style={{ marginBottom: '5px', display: 'inline-block' }} className={`label pending`}>
                    Recurring Order
                  </span>

                  {Dkey.endedRecurringOrder && (
                    <div>
                      <span className={`label cancelled`}>Recurrence Ended</span>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>

          <div>{Dkey.newRecurringOrder && isFirstDateColumn && <span className={`label assigned`}>Created from a Recurring Order</span>}</div>
        </TableCell>
      );

      break;
    }
    case "button": {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          <Button className={`${Dkey[key.id] == false ? 'bg-danger' : 'bg-success'}
          text-white CBmargin text-capitalize`} onClick={() => key.action(Dkey)}>
            {Dkey[key.id] == false ? 'Paused' : 'Running'}
          </Button>
        </TableCell>
      );
      break;
    }

    case 'currency': {
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          {Format_Number(Dkey[key.id])}
          {/* send pharmacyProvince feild */}
          {/* ${getPriceWithoutTax(Dkey[key.id], Dkey.pharmacyProvince)} */}
        </TableCell>
      );
    }
    case 'allPharmacyTotal': {
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          {Format_Total_Number(Dkey[key.id])}
        </TableCell>
      );
    }
    case 'fee': {
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          {/* {Format_Number(Dkey[key.id])} */}
          {/* send pharmacyProvince feild */}
          ${getPriceWithoutTax(Dkey[key.id], Dkey.pharmacyProvince)}
        </TableCell>
      );
    }
    case 'totalOrder': {
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          {Dkey[key.id]}
        </TableCell>
      );
    }
    case 'invoiceStatus': {
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          {Dkey[key.id] ? Dkey[key.id] : 'Unpaid'}
        </TableCell>
      );
    }
    case 'subtotal': {
      const provinceTax = provinceTaxes[Dkey['pharmacyDetails']] ? provinceTaxes[Dkey['pharmacyDetails']] : 0;
      const subTotal = (Dkey['totalMoneySpent'] * 100) / (100 + provinceTax);
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          {Format_Number(subTotal)}
        </TableCell>
      );
    }

    case 'allExpenseSubTotal': {
      return (
        <TableCell padding="none" align="center" key={index} style={key.style ? key.style : {}}>
          ${Number(Dkey[key.id]).toFixed(2)}
        </TableCell>
      );
    }

    default: {
      if (Array.isArray(Dkey[key.id]) || key.numeric) {
        return (
          <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
            {Dkey[key.id] && Dkey[key.id].length > 0 ? Dkey[key.id].length : 0}
          </TableCell>
        );
      } else {
        return (
          <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
            {Dkey[key.id] || '--'}
            {key.id === 'name' && !Dkey.uberOrgId && <span className={`label ${Dkey[key.id]}`}>NO ORG ID</span>}
          </TableCell>
        );
      }

      break;
    }
  }
};
class DataTableBody extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { loading, page, rowsPerPage, data, column, actions, actionBtn, popupBtn, refundBtn, centerText, customBtn, EditBtn, MarkAsPaidBtn, enableSelectionMode, selectedPharmacies, onCheckboxToggle } = this.props;
    const textAlignStyle = centerText ? { textAlign: 'center' } : {};

    let columnNames = column
      .map((key) => {
        return key;
      })
      .filter((key) => key != '_id' && key != 'action');
    let notDisplay = ['_id', 'action'];
    return (
      <TableBody>
        {loading === false &&
          data.length > 0 &&
          data.map((Dkey, index) => {
            return (
              <TableRow hover tabIndex={-1} key={Dkey._id}>
                {enableSelectionMode && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedPharmacies.some(ph => ph._id === Dkey._id)}
                      onChange={() => onCheckboxToggle(Dkey)}
                    />
                  </TableCell>
                )}
                <TableCell padding="none" style={textAlignStyle} >
                  {++index + page * rowsPerPage}
                  {Dkey.adminNotes && Dkey.adminNotes.length > 0 && (
                    <span className="label bg-blue mx-2" style={textAlignStyle} ></span>
                  )}
                </TableCell>

                {column.map((key, index) => {
                  if (!notDisplay.includes(key.id)) {
                    return TableCellPrint(Dkey, key, index);
                  }
                })}
                {actions && (
                  <TableCell padding="none" align="right" key={index}>
                    <Action actions={actions} id={Dkey._id} />
                  </TableCell>
                )}
                {actionBtn && (
                  <TableCell padding="none" align="right" key={index}>
                    <NavLink to={`${actionBtn.link}${Dkey._id}`}>
                      <Button className="bg-amber text-white CBmargin">
                        <i className={`zmdi ${actionBtn.icon}`} /> {actionBtn.title}
                      </Button>
                    </NavLink>
                  </TableCell>
                )}
                {refundBtn && (
                  <TableCell padding="none" align="right" key={`refund-${Dkey._id}`}>
                    <Button
                      className="bg-dark text-white CBmargin p-3"
                      onClick={() => {
                        if (refundBtn.disabled && refundBtn.disabled(Dkey)) {
                          return;
                        }
                        refundBtn.action(Dkey._id);
                      }}                    >
                      {refundBtn.label}
                    </Button>
                  </TableCell>
                )}
                {EditBtn && (
                  <TableCell padding="none" align="right" key={`edit-${Dkey._id}`}>
                    <Button
                      className={`${EditBtn.disabled && EditBtn.disabled(Dkey) ? "bg-grey" : "bg-amber"} text-white CBmargin p-3`}
                      onClick={() => EditBtn.action(Dkey._id)}
                      style={EditBtn.style}
                      disabled={EditBtn.disabled && EditBtn.disabled(Dkey)}
                    >
                      {EditBtn.disabled && EditBtn.disabled(Dkey) ? "Paid" : EditBtn.label}
                    </Button>
                  </TableCell>
                )}
                {MarkAsPaidBtn && (
                  <TableCell padding="none" align="right" key={`markpaid-${Dkey._id}`}>
                    <Button
                      className={`${MarkAsPaidBtn.disabled && MarkAsPaidBtn.disabled(Dkey) ? "bg-grey" : "bg-green"} text-white CBmargin`}
                      onClick={() => MarkAsPaidBtn.action(Dkey)}
                      disabled={MarkAsPaidBtn.disabled && MarkAsPaidBtn.disabled(Dkey)}
                      style={{
                        fontSize: '10px',
                        padding: '4px 8px',
                        minWidth: '70px',
                        height: '28px',
                      }}
                    >
                      {MarkAsPaidBtn.label}
                    </Button>
                  </TableCell>
                )}


                {popupBtn && (
                  <TableCell padding="none" align="right" key={index}>
                    <Button className="bg-amber text-white CBmargin" onClick={(e) => popupBtn.action(true, Dkey._id)}>
                      <i className={`${popupBtn.icon ? popupBtn.icon : 'zmdi zmdi-eye'}`} />
                    </Button>
                  </TableCell>
                )}
                {customBtn && (
                  <TableCell padding="none" align="right" key={index}>
                    <Button
                      className={customBtn.className(Dkey)}
                      onClick={() => customBtn.action(Dkey)}
                      disabled={customBtn.disabled(Dkey)}
                    >
                      <i className={customBtn.icon(Dkey)} />
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            );
          })}

        {loading === false && data.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              No data Found!
            </TableCell>
          </TableRow>
        )}
        {loading === true && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              <Loading />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    );
  }
}

class DataTablePagination extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { count, page, rowsPerPage, rowsPerPageOptions, onChangePage } = this.props;
    return (
      <TableFooter>
        <TableRow>
          <TablePagination count={count} rowsPerPage={rowsPerPage} page={page} onChangePage={onChangePage} rowsPerPageOptions={rowsPerPageOptions} />
        </TableRow>
      </TableFooter>
    );
  }
}

class Action extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      anchorEl: undefined,
      menuState: false,
    };

    this.onOptionMenuSelect = this.onOptionMenuSelect.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  onOptionMenuSelect = (event) => {
    this.setState({ menuState: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ menuState: false });
  };

  render() {
    const { id, actions } = this.props;
    const { menuState, anchorEl } = this.state;

    return (
      <Fragment>
        <IconButton key={id} onClick={(e) => this.onOptionMenuSelect(e)}>
          <i className="zmdi zmdi-more-vert" />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={menuState}
          onClose={(e) => this.handleRequestClose()}
          MenuListProps={{
            style: {
              width: 93,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          {actions &&
            actions.map((key, index) => {
              if (key.action) {
                return (
                  <MenuItem key={key['label']} onClick={(e) => key.action(true, id)} className="customIcon">
                    <ListItemIcon>
                      <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    View
                  </MenuItem>
                );
              } else if (key['label'] === 'Delete') {
                return (
                  <MenuItem key={key['label']} onClick={(e) => this.handleRequestClose()} className="customIcon">
                    <a href="javascript:void(0)" onClick={() => key.link(id)}>
                      <ListItemIcon>
                        <DeleteForeverIcon fontSize="small" />
                      </ListItemIcon>
                      Delete
                    </a>
                  </MenuItem>
                )
              }
              else if (typeof key.link === 'function') {
                // Callback actions (e.g. "Add MyRx", "Add On Ship")
                return (
                  <MenuItem key={key['label']} onClick={(e) => this.handleRequestClose()} className="customIcon">
                    <a href="javascript:void(0)" onClick={() => key.link(id)}>
                      <ListItemIcon>
                        <AddIcon fontSize="small" />
                      </ListItemIcon>
                      {key['label']}
                    </a>
                  </MenuItem>
                );
              } else {
                return (
                  <MenuItem key={key['label']} onClick={(e) => this.handleRequestClose()} className="customIcon">
                    <NavLink to={`${key.link}/${id}`}>
                      <ListItemIcon>
                        {key['icon'] !== '' && key['icon']}
                        {key['label'] === 'View' && <VisibilityIcon fontSize="small" />}
                        {key['label'] === 'Edit' && <EditIcon fontSize="small" />}
                        {key['label'] === 'Pay' && <MonetizationOnIcon fontSize="small" />}
                      </ListItemIcon>
                      {key['label']}
                    </NavLink>
                  </MenuItem>
                );
              }
            })}
        </Menu>
      </Fragment>
    );
  }
}

const ActionLink = (props) => {
  const { index, actionBtn, id } = props;
  return (
    <TableCell padding="none" align="right" key={index}>
      <NavLink to={`${actionBtn.link}${id}`}>
        <Button className="bg-amber text-white CBmargin">
          <i className={`zmdi ${actionBtn.icon}`} /> {actionBtn.title}
        </Button>
      </NavLink>
    </TableCell>
  );
};

const ActionPopup = (props) => {
  const { key, action, id, title, icon } = props;
  return (
    <TableCell padding="none" align="right" key={key}>
      <Button className="bg-amber text-white CBmargin" onClick={() => action(id)}>
        <i className={`zmdi ${icon}`} /> {title}
      </Button>
    </TableCell>
  );
};
ActionPopup.defaultProps = {
  key: Math.random(),
  title: '',
  icon: 'Zmdi-delete',
};

// DataTable= withRouter(DataTable)
// DataTableHead= withRouter(DataTableHead)
// DataTableBody= withRouter(DataTableBody)
// DataTablePagination= withRouter(DataTablePagination)
export {
  DataTable,
  DataTableHead,
  DataTableBody,
  DataTablePagination,
  Action,
  ActionPopup,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  ActionLink,
  moment,
};
